import axios from 'axios'

import config from '../../config'
import { getHeaders, downloadFromS3 } from './helpers'

//* ~~~~~~ GENERIC FILE UPLOAD ~~~~~~

// Uploads a file to S3
const uploadFile = async (file, url = '/media') => {
  if (!file) {
    return null
  }

  const headers = await getHeaders()
  const data = new FormData()
  data.append('data', file)
  const response = await axios.post(`${config.apiBaseUri}${url}`, data, {
    headers: {
      ...headers.headers,
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data?.data || null
}

//* ~~~~~~ DOMAIN SPECIFIC FILE UPLOAD ~~~~~~

// Uploads a file for an avatar
export const uploadFileAvatar = async (file, id) => {
  return await uploadFile(file, '/users/avatars')
}

// Uploads a file for a task
export const uploadFileTask = async file => {
  return await uploadFile(file, '/tasks/media')
}

// Uploads a file for an event
export const uploadFileEvent = async file => {
  return await uploadFile(file, '/events/media')
}

// Uploads a file for an article
export const uploadFileArticle = async file => {
  return await uploadFile(file, '/articles/media')
}

// Uploads a file for a user
export const uploadFileUser = async file => {
  return await uploadFile(file, '/users/media')
}

//* ~~~~~~ MISC MEDIA ~~~~~~

// Gets the transcript file
export const requestTranscript = async (id, data, isDirect) => {
  const { emails, ...rest } = data
  let query = new URLSearchParams(rest).toString()
  if (emails) {
    query += `&emails[]=${emails.join('&emails[]=')}`
  }
  if (query.length) {
    query = `?${query}`
  }

  const path = isDirect ? 'users' : 'sessions'
  const url = `${config.apiBaseUri}/transcripts/${path}/${id}${query}`
  let signedUrl
  try {
    const headers = await getHeaders()

    const res = await axios({ method: 'GET', url, ...headers })
    signedUrl = res.headers['x-location']
  } catch (e) {
    signedUrl = e.response.headers['x-location']
  }

  return await downloadFromS3(signedUrl)
}

// Gets the S3 media from media id
export const getMedia = async id => {
  const signedUrl = await getSignedURL(id)
  return await downloadFromS3(signedUrl)
}

// Gets signed url for media
export const getSignedURL = async id => {
  let signedUrl
  const headers = await getHeaders()

  await axios({
    method: 'GET',
    url: `${config.apiBaseUri}/media/${id}/download`,
    ...headers
  }).catch(e => {
    signedUrl = e.response.headers['x-location']
  })

  return signedUrl
}
